var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { useState, useEffect, useRef } from 'react';
import { useFocus } from '../..';
var useDrawer = function (row) {
    var _a = __read(useState('Closed'), 2), drawerState = _a[0], setDrawerState = _a[1];
    var _b = __read(useFocus(), 2), drawerToggleRef = _b[0], setToggleFocus = _b[1];
    var _c = __read(useFocus(), 2), drawerTargetRef = _c[0], setTargetFocus = _c[1];
    var drawerTriggerRef = useRef(null);
    /**
     * setTriggerFocus is performed as an effect since there is a table pattern
     * where the trigger buttons are disabled when the drawer opens. Disabled
     * buttons cannot be focused, so using an effect allows the trigger button to
     * be enabled before focus is set.
     */
    var _d = __read(useState(false), 2), isReadyToFocus = _d[0], setIsReadyToFocus = _d[1];
    var setTriggerFocus = function () {
        setIsReadyToFocus(true);
    };
    useEffect(function () {
        var _a;
        if (isReadyToFocus) {
            (_a = drawerTriggerRef.current) === null || _a === void 0 ? void 0 : _a.focus();
            setIsReadyToFocus(false);
        }
    }, [isReadyToFocus]);
    useEffect(function () {
        // drawer was closed
        if (!row.isExpanded) {
            setDrawerState('Closed');
            return;
        }
        // drawer was opened
        if (drawerState !== 'OpenedWithToggle') {
            setDrawerState('OpenedWithTrigger');
        }
        setTargetFocus();
    }, [row.isExpanded]);
    var setFocus = function () {
        switch (drawerState) {
            case 'OpenedWithToggle':
                setToggleFocus();
                break;
            case 'OpenedWithTrigger':
            default:
                setTriggerFocus();
        }
    };
    var toggleDrawer = function (open) {
        row.toggleRowExpanded(open);
    };
    var openDrawerWithToggle = function () {
        setDrawerState('OpenedWithToggle');
        row.toggleRowExpanded(true);
    };
    var closeDrawerAndFocus = function () {
        row.toggleRowExpanded(false);
        setFocus();
    };
    return {
        toggleDrawer: toggleDrawer,
        openDrawerWithToggle: openDrawerWithToggle,
        closeDrawerAndFocus: closeDrawerAndFocus,
        drawerTriggerRef: drawerTriggerRef,
        drawerToggleRef: drawerToggleRef,
        drawerTargetRef: drawerTargetRef,
        isDrawerOpen: row.isExpanded,
    };
};
export default useDrawer;
//# sourceMappingURL=useDrawer.js.map